import { Button, Box, CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';
import useIntercomMessenger from '../../../hooks/useIntercomMessenger';
import HelpIcon from '@mui/icons-material/Help';
import { INTERCOM_ENABLED } from '../../../config';

const HelpButton = styled(Button)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: 'auto',
    padding: theme.spacing(2.5, 3),
    margin: theme.spacing(0, 2.5, 2.5, 2.5),
    borderRadius: Number(theme.shape.borderRadius) * 1.5,
    backgroundColor:
        theme.palette.mode === 'dark' ? theme.palette.grey[950] : theme.palette.tan.lighter,
    color: theme.palette.text.secondary,
    textTransform: 'none',
    fontWeight: 500,
    transition: theme.transitions.create(['background-color', 'color'], {
        duration: theme.transitions.duration.shorter,
    }),
    '&:hover': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        '& .MuiSvgIcon-root': {
            color: theme.palette.primary.contrastText,
        },
    },
}));

interface NavbarHelpProps {
    isCollapse?: boolean;
}

export default function NavbarHelp({ isCollapse }: NavbarHelpProps) {
    const { show, isReady } = useIntercomMessenger();

    const handleClick = () => {
        if (isReady) {
            show();
        }
    };

    if (!INTERCOM_ENABLED) {
        return null;
    }

    if (isCollapse) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', px: 2.5, pb: 2.5 }}>
                <Button
                    onClick={handleClick}
                    variant="text"
                    disabled={!isReady}
                    sx={{
                        minWidth: 44,
                        width: 44,
                        height: 44,
                        borderRadius: 1.5,
                        color: 'text.secondary',
                        backgroundColor: (theme) =>
                            theme.palette.mode === 'dark' ? theme.palette.grey[950] : 'tan.lighter',
                        '&:hover': {
                            backgroundColor: 'primary.main',
                            color: 'primary.contrastText',
                        },
                    }}
                >
                    {!isReady ? <CircularProgress size={20} /> : <HelpIcon />}
                </Button>
            </Box>
        );
    }

    return (
        <HelpButton
            onClick={handleClick}
            variant="text"
            disabled={!isReady}
            startIcon={!isReady ? <CircularProgress size={20} /> : <HelpIcon />}
        >
            Get Help
        </HelpButton>
    );
}
